var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"main",attrs:{"id":"main"}}),_c('div',{staticClass:"main1",attrs:{"id":"main1"}}),(this.BodyId!=114)?_c('div',{staticClass:"main2",attrs:{"id":"main2"}}):_vm._e(),(this.BodyId!=114)?_c('div',{staticClass:"main3",attrs:{"id":"main3"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }